import { ArrowLeftIcon } from "@/lib/icons"
import { Link } from "./Anchor"
import { Routes } from "@/constants/routes"

interface BackIconProps {
	href: Routes
}
export const BackIcon = ({ href }: BackIconProps) => (
	<Link href={href} data-testid="back-icon" className="inline-flex">
		<ArrowLeftIcon className="size-6 shrink-0 text-gray-400 hover:text-gray-700" />
	</Link>
)
